import React, { useState, useEffect } from "react";
import { Spin, Form, Input, Collapse, InputNumber, Row, Col, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import IntlMessages from "../../util/IntlMessages";
import ProductObj from "./ProductObj";
import { fetchCurrentSalesOrder, getDecryptID, isEmptyObject, loadShowPrompPrompt } from "../../appRedux/actions";
import { WarningOutlined } from "@ant-design/icons";

const ProductList = (props) => {
  const { discountPerm, availableUsers } = props;
  const dispatch = useDispatch();
  const Panel = Collapse.Panel;

  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  );
  const getIsProductLoading = useSelector(
    ({ MainSale }) => MainSale.getIsProductLoading
  );
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  );
  const getPromoPrompt = useSelector(
    ({ MainSale }) => MainSale.getPromoPrompt
  );
  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj);
  const showInventoryPopup = useSelector(({ Sell }) => Sell.showInventoryPopup);

  const getIsDiscountRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsDiscountRowVisible
  );

const getIsNotesRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsNotesRowVisible
  );

  function callback(key) {

  }
  const getContainerClassName = () => {
    if (getIsNotesRowVisible && getIsDiscountRowVisible) {
      return 'cart-scroll-div-note-discount';
    } else if (getIsNotesRowVisible) {
      return 'cart-scroll-div-note';
    } else if (getIsDiscountRowVisible) {
      return 'cart-scroll-div-discount';
    } else {
      return 'cart-scroll-div-height';
    }
  };
  return (
    <>
      {getPromoPrompt && !isEmptyObject(getPromoPrompt) && !isEmptyObject(getCustomerObj) &&
        (getDecryptID(getCurrentSalesOrderStatusID) != getDecryptID(fetchCurrentSalesOrder("Delivery, unfulfilled")) ||
          getDecryptID(getCurrentSalesOrderStatusID) != getDecryptID(fetchCurrentSalesOrder("PickUp, unfulfilled"))) &&
        (
          <Panel
            showArrow={false}
            collapsible="disabled"
            className="custom-ant-collapse-item"
            header={
              <div className="custom-unfulfil-bar">
                <IntlMessages id="promoprompt.av" />{" "}
                <strong
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => dispatch(loadShowPrompPrompt(true))}
                >
                  <IntlMessages id="promoprompt.details" />
                </strong>
              </div>
            }
            key={234128900567}
          ></Panel>
        )}
      {(getDecryptID(getCurrentSalesOrderStatusID) == getDecryptID(fetchCurrentSalesOrder("Delivery, unfulfilled")) ||
        getDecryptID(getCurrentSalesOrderStatusID) == getDecryptID(fetchCurrentSalesOrder("PickUp, unfulfilled"))) && (
          <Panel
            showArrow={false}
            collapsible="disabled"
            className="custom-ant-collapse-item"
            header={
              <div className="custom-unfulfil-bar">
                {getDecryptID(getCurrentSalesOrderStatusID) == "4" ?
                  <IntlMessages id="mainsale.fulfil.deliverbar" /> :
                  <IntlMessages id="mainsale.fulfil.pickupbar" />}
              </div>
            }
            key={234128900567}
          ></Panel>
        )}
      {showInventoryPopup && (
        <Panel
          showArrow={false}
          collapsible="disabled"
          className="custom-ant-collapse-item"
          header={
            <div className="custom-inventory-bar">
              <WarningOutlined style={{ marginRight: 10, marginBottom: 7, display: "inline-grid" }} />
              <span>
                <IntlMessages id="sell.cart.inventory.popup" />
              </span>
            </div>
          }
          key={2777778900567}
        ></Panel>
      )}
      <Collapse defaultActiveKey={["1"]} onChange={callback} accordion     className={`cart-items Cart-Products theme-scroll ${getContainerClassName()}`}>
        {getReduxSaleProductJsonData && getReduxSaleProductJsonData.length > 0 &&
          getReduxSaleProductJsonData.map((productObj, key) => {
            return (
              <ProductObj
                key={key}
                data={productObj}
                discountPerm={discountPerm}
                callback={callback}
                availableUsers={availableUsers}
              />
            );
          })}
        {getIsProductLoading && (
          <Panel
            showArrow={false}
            collapsible="disabled"
            className="custom-ant-collapse-item"
            header={
              <div className="custom-text-center">
                <Spin
                  tip={<IntlMessages id="common.resource.loading" />}
                  spinning={getIsProductLoading}
                ></Spin>
              </div>
            }
            key={234567}
          ></Panel>
        )}
      </Collapse>
    </>
  );
};

export default ProductList;
